/* Vesper Cocktails: regular page template.
   - tidies merchant HTML (blank paragraphs, wide tables)
   - builds the "On This Page" navigation from the body headings, with scroll-spy */
(function () {
  'use strict';

  function slugify(text) {
    var t = (text || '').toLowerCase();
    if (t.normalize) t = t.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    return t.replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function tidy(body) {
    // Blank spacer paragraphs (<p>&nbsp;</p>, <p><br></p>) would double the paragraph margin.
    var ps = body.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.querySelector('img,iframe,video,svg,input,canvas,a')) continue;
      if (!p.textContent.replace(/[\s ​]+/g, '')) p.parentNode.removeChild(p);
    }
    // Wide tables scroll inside their own box instead of the page.
    var ts = body.querySelectorAll('table');
    for (var j = 0; j < ts.length; j++) {
      var t = ts[j];
      if (t.parentNode.classList && t.parentNode.classList.contains('vc-page__tablewrap')) continue;
      var w = document.createElement('div');
      w.className = 'vc-page__tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    }
  }

  function buildToc(root, body) {
    var nav = root.querySelector('[data-vc-page-toc]');
    if (!nav) return;
    var list = nav.querySelector('[data-vc-page-toc-list]');
    var sel = nav.getAttribute('data-levels') === 'h2h3' ? 'h2, h3' : 'h2';
    var heads = [].filter.call(body.querySelectorAll(sel), function (h) {
      return h.textContent.replace(/[\s ]+/g, '');
    });
    if (heads.length < 2) {
      nav.parentNode.removeChild(nav);
      root.classList.add('vc-page-body--no-toc');
      return;
    }
    var links = [];
    heads.forEach(function (h, idx) {
      if (!h.id) {
        var base = slugify(h.textContent) || 'section-' + (idx + 1);
        var id = base, n = 2;
        while (document.getElementById(id)) { id = base + '-' + n++; }
        h.id = id;
      }
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'vc-page-toc__link' + (h.tagName === 'H3' ? ' vc-page-toc__link--sub' : '');
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + h.id); } catch (err) {}
      });
      list.appendChild(a);
      links.push(a);
    });

    var ticking = false;
    function spy() {
      ticking = false;
      var active = 0;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top <= 170) active = i; else break;
      }
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    spy();
  }

  function init(root) {
    if (!root || root.__vcPageInit) return;
    root.__vcPageInit = true;
    var body = root.querySelector('[data-vc-page-body]');
    if (!body) return;
    tidy(body);
    buildToc(root, body);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-vc-page]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-vc-page]') : null;
    if (r) init(r);
  });
})();
